define('lib/transforms/slp.series',[], function () {
  return function slpSeriesXform(reqSeries) {
    var req = {};
    var chosenSeries = reqSeries.split(',');
    delete req.series;
    var makes = [];
    var years = [];
    var models = [];
    var yearModels = [];
    chosenSeries.forEach(function (seriesId) {
      var tokens = seriesId.split('|');
      makes.push('Toyota');
      years.push(tokens[0]);
      models.push(tokens[1]);
      yearModels.push(tokens.join(' '));
    });
    req.vehicleMake = makes[0] || 'N/A';
    req.vehicleModel = models[0] || 'N/A';
    req.vehicleYear = years[0] || 'N/A';
    if (yearModels.length > 1) {
      req.moreSeries = '\n\n:::ALSO INTERESTED IN VEHICLES:::\n\n' + yearModels.join(', ');
    }

    return req;
  };
});

